<template>
    <div :class="{ 'h-100': loading || !notifications.length }">
        <div v-if="loading" style="height: 100%; width: 100%" class=" m-auto d-flex justify-center align-center">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </div>
        <v-row v-if="!loading && notifications.length" class="px-2 " :class="{ 'mt-3': !loading }">
            <!-- <div > -->
            <v-col  cols="12" v-for="(item, index) in notifications" :key="index" class="">
                <v-card  class="rounded-BigLg" height="80">
                    <v-card-text class="pe-0 py-0 h-100" style="height: 70px">
                        <v-row class="h-100">
                            <v-col cols="10" class="d-flex justify-center" align-self="center">
                                <span class="text-start black--text">
                                    {{ item.body || item.title }}
                                </span>
                            </v-col>

                            <v-col cols="2" class="d-flex justify-end ps-0 py-0" align-self="center">
                                <v-btn color="secondary" height="80" style="" small class="rounded-btn-card">
                                    <v-icon color="white"> mdi-bell </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- </div> -->
            <!-- notifications -->
        </v-row>

        <div v-if="!loading && !notifications.length" style="height: 100%; width: 100%" class=" m-auto d-flex flex-column justify-center align-center">
            <v-icon size="30" color="primary">
                mdi-bell-off
            </v-icon>
            <span>
              لا يوجد اشعارت لعرضها!
            </span>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data () {
        return {
            loading: false
        }
    },

    computed: {
        ...mapState({
            notifications: state => state.notification.notifications
        })
    },

    created () {
        this.loading = true
        this.$store.dispatch('notification/fetchAll').then((notifications) => {
            if (notifications.some(n => !n.isDelivered)) {
                this.$store.dispatch('notification/markAllRead')
            }
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>
